export const tr = {
    nav: {
      about: 'Hakkımızda',
      tours: 'Seyahat',
      realEstate: 'Gayrimenkul',
      news: 'Haberler',
      insights: 'Yatırım Rehberi',
      contact: 'İletişim',
      tourDropdown: {
        dayTours: 'İstanbul Günlük Turlar',
        shoreExcursions: 'Kruvaziyer Turları',
        foodTour: 'İstanbul Yemek Turu',
        reConsulting: 'Gayrimenkul Danışmanlık Turu (Ücretsiz)',
        layoverTour: 'İstanbul Transit Turu',
        medicalTourism: 'Sağlık Turizmi'
      },
      realEstateDropdown: {
        besiktas: 'Beşiktaş',
        florya: 'Bakırköy',
        kanalIstanbul: 'Kanal İstanbul',
        skyland: 'Büyük Gökdelen',
        merkezefendi: 'Zeytinburnu',
        tualComfort: 'Kanal İstanbul 2.',
        referansBeylikduzu: 'Avrupa Yakası Prime Rezidansları'
      }
    },
    hero: {
      title: 'İstanbul\'a Açılan Kapınız',
      subtitle: 'Yatırım ve Turizm Mükemmelliği',
      motto: '"Türkiye\'de güvenilir ortağınız"',
      exploreTours: 'Turları Keşfet',
      viewProperties: 'Gayrimenkulleri İncele'
    },
    about: {
      title: 'Viaturkey Hakkında',
      intro: 'Viaturkey, İstanbul merkezli, Turizm, Danışmanlık ve Gayrimenkul Danışmanlık Hizmetleri alanlarında faaliyet gösteren başarılı bir tam hizmet şirketidir.',
      tourism: 'Turizm Hizmetleri',
      tourismDesc: 'İhtiyaçlarınıza özel kapsamlı İstanbul ve Türkiye turizm deneyimleri.',
      realEstate: 'Gayrimenkul Danışmanlığı',
      realEstateDesc: 'Türk gayrimenkul yatırım fırsatlarında uzman rehberlik.',
      realEstateExtra: 'Gayrimenkul mülk yönetimi hizmetleri talep üzerine ve vekaletname ile sağlanabilir.',
      residence: 'İkamet İzni',
      residenceDesc: 'Türk ikamet izni başvurularında profesyonel yardım.',
      citizenship: 'Türk Vatandaşlığı',
      citizenshipDesc: 'Türk vatandaşlığı edinim sürecinde eksiksiz destek.',
      establishBusiness: 'İş Kurma',
      establishBusinessDesc: 'Türkiye\'de işletmenizi kurma ve tescil etme konusunda uzman yardımı.',
      workPermit: 'Çalışma İzni Alma',
      workPermitDesc: 'Yabancı uyruklu kişiler için Türkiye\'de çalışma izni başvurularında kapsamlı rehberlik.',
      founderGreeting: 'Merhaba, ben Viaturkey Investments & Tourism Co.\'nun kurucu ortağıyım. Adım Akın Güzel. Turizm Operasyonları ve Gayrimenkul Danışmanlığı alanında seri girişimciyim ve ayrıca İstanbul, Türkiye merkezli güvenilir bir yerel iş ortağıyım. Sahadaki uzman ekibimizle, Türkiye\'deki planlarınız hakkında sizinle konuşmayı dört gözle bekliyoruz.',
      founderName: 'Akın Güzel',
      founderTitle: 'Kurucu Ortak, Viaturkey Investments & Tourism Co.'
    },
    interestField: {
      title: 'Türkiye Hakkında İlgi Alanınız',
      travel: 'Seyahat Viaturkey',
      travelDesc: 'Özel turlar ve uzman yerel rehberlerle İstanbul\'u keşfedin',
      invest: 'Yatırım Viaturkey',
      investDesc: 'İstanbul\'da lüks gayrimenkul ve yatırım fırsatları',
      news: 'Haberler Viaturkey',
      newsDesc: 'Türkiye\'den en son yaşam ve iş haberleri',
      insights: 'Yatırım Rehberi Viaturkey',
      insightsDesc: 'Yatırımcılar için İstanbul mega projeleri, piyasa verileri ve turizm rakamları',
    },
    tours: {
      title: 'Turizm Hizmetleri',
      subtitle: 'Uzman yerel rehberlerle İstanbul ve Türkiye\'yi keşfedin',
      whyBookTitle: 'Neden Bizimle Rezervasyon Yapmalısınız?',
      bestPrice: 'En İyi Fiyat Garantisi – Doğrudan Rezervasyon Yapın ve Tasarruf Edin',
      bestPriceDesc: 'Web sitemiz veya e-posta yoluyla doğrudan bize ulaşarak, %25\'e varan komisyon alan TripAdvisor / Viator / Get Your Guide gibi üçüncü taraf platformları atlarsınız. Bu tasarrufları doğrudan rezervasyon indirimi olarak size yansıtmayı tercih ediyoruz.',
      tailorMade: 'Kişiye Özel Programlar',
      tailorMadeDesc: 'Yolculuğunuz herkese uyan tek tip olmamalı. Aklınızda belirli bir tarihi mekan veya hayalini kurduğunuz gizli bir yer varsa, her detayı kişisel ilgi alanlarınıza göre özelleştirmekte uzmanız.',
      expertGuides: 'Uzman Yerel Rehberler',
      expertGuidesDesc: 'En popüler rehberlerimiz genellikle yoğun talep görür ve programları hızla dolar. Önceden rezervasyon yaparak, tercih ettiğiniz tarih ve saatte birinci sınıf bir profesyonelle buluşmanızı garanti altına alırsınız.',
      transparency: 'Tam Şeffaflık',
      transparencyDesc: 'Gizli ücret veya sürpriz yok. Programınız, süresi ve tam olarak nelerin dahil olduğu hakkında net bilgi sunuyoruz. Maceranızı sonlandırmadan önce koşulları ve iptal politikasını her zaman bileceksiniz.',
      duration: 'Süre',
      highlights: 'Öne Çıkanlar',
      included: 'Dahil',
      excluded: 'Hariç',
      contactPrice: 'En iyi fiyat için iletişime geçin',
      inquireNow: 'Bilgi Al',
      alsoAvailable: 'Ayrıca Mevcut',
      flexibleToursIntro: 'Hristiyan Mirası Turları, Arkeoloji Turları ve Alışveriş Turları da planınıza uygun olarak kendi hızınızda esnek bir programla yapılabilir.',
      flexibleToursContact: 'Detaylar için lütfen iletişime geçin',
      christianHeritage: 'Hristiyan Mirası Turları',
      archaeologyTours: 'Arkeoloji Turları',
      shoppingTours: 'Alışveriş Turları',
      pricingBanner: 'Özel Kültürel Rehberlik - Tur Yönetimi grup başı 160$\'dan başlayan fiyatlarla, 2-8 kişi.',
      pricingSolo: 'Bireysel gezginler veya FIT / Teşvik Grupları için lütfen fiyat teklifi isteyiniz.',
      priceFrom200: '200 USD\'den başlayan fiyatlarla',
      priceFrom150: 'Kişi başı 150 USD\'den başlayan fiyatlarla',
      priceFrom175: 'Grup başı 175$\'dan başlayan fiyatlarla',
      priceFrom160: 'Grup başı 160$\'dan başlayan fiyatlarla',
      priceFrom185: 'Grup başı 185$\'dan başlayan fiyatlarla',
      contactWhatsApp: 'WhatsApp ile İletişim',
      commissionWarning: {
        title: 'Önemli Uyarı',
        message: 'Lütfen unutmayın ki, bu 3 web sitesi tur hizmetinden kişi başı %25 komisyon almaktadır. Yani gerçek operasyonlara, uzmanlığa ve emeğe hiç dahil olmayan üçüncü taraflara para ödemiş olursunuz!',
        directMessage: 'Doğrudan bizimle rezervasyon yaptığınızda, paranız aracısız olarak doğrudan hizmet sağlayıcıya gider — gizli ücret yok.'
      },
      businessDining: {
        tip: 'İstanbul\'da İş Odaklı Gezginler İçin İpuçları',
        title: 'İstanbul\'da İş Toplantıları İçin En İyi Restoranlar',
        specialty: 'Uzmanlık',
        steakhouseTitle: 'Steakhouse ve Kebap İkonları',
        seafoodTitle: 'Boğaz ve Sahil Deniz Ürünleri',
        italianTitle: 'Sofistike Dünya ve İtalyan Mutfağı',
        fineDiningTitle: 'Manzaralı Fine Dining'
      },
      videoSection: {
        title: 'İstanbul\'u Bizimle Keşfedin',
        desc: 'İstanbul\'un en ikonik simgelerine rehberli turumuza katılın — muhteşem Sultanahmet Camii ve tarihi Ayasofya. Zengin tarihi, çarpıcı mimariyi ve kültürel mirası deneyimleyin.'
      },
      realEstateConsulting: {
        title: 'Gayrimenkul Danışmanlık Hizmeti',
        vanInfo: 'Özel şoförlü araç ek ücretle ayarlanabilir.',
        consultingInfo: 'Minimum 3-5 saat ücretsiz gayrimenkul danışmanlığı sağlanacaktır.',
        description: 'Bu hizmet, İstanbul\'daki Gayrimenkul / Yatırım pazarı hakkında en detaylı bilgiyi edinmek isteyen misafirlere (özel talep ile) sunulabilir.',
        ctaText: 'Türkiye\'deki Yatırım Planlarınızı Konuşmak İçin 15 Dakikalık Bir Görüşme Planlayın'
      },
      includedItems: [
        'Özel Kişisel Tur Rehberi',
        'Tüm Müzelere Hızlı Giriş (Ayasofya hariç)',
        'Akademisyen Bilgili Rehber',
        '5-8 saat tur süresi',
        'Otelden klimalı araçla/araçsız alınma'
      ],
      excludedItems: [
        'Rehber bahşişi',
        'Tüm müze giriş ücretleri',
        'Öğle yemeği',
        'Tur süresince her türlü kişisel harcama'
      ],
      tourDetails: {
        '1': {
          name: 'Günlük Tarihi Yarımada İstanbul Turu',
          description: 'İkonik simge yapıları ziyaret ederek İstanbul\'un tarihi kalbini keşfedin. Uzman yerel rehberiniz eşliğinde minimum 5-8 saat süre.',
          duration: 'Minimum 5-8 saat',
          highlights: ['Ayasofya', 'Sultanahmet Camii', 'Topkapı Sarayı', 'Kapalıçarşı', 'Hipodrom'],
          whatsappMsg: 'Merhaba, Günlük Tarihi Yarımada İstanbul Turu ile ilgileniyorum. Detayları paylaşır mısınız?'
        },
        '2': {
          name: 'Kruvaziyer Turları - Tarihi Yarımada İstanbul Turu',
          description: 'Kruvaziyer yolcuları için mükemmel! Limandan alınma ve bırakma ile İstanbul\'un Tarihi Yarımadasının kapsamlı turu. Minimum 5-8 saat süre.',
          duration: 'Minimum 5-8 saat',
          highlights: ['Limandan Alınma', 'Tarihi Yarımada Gezileri', 'Limana Dönüş'],
          whatsappMsg: 'Merhaba, Kruvaziyer Turları ile ilgileniyorum. Detayları paylaşır mısınız?'
        },
        '3': {
          name: 'İstanbul / Sabiha Gökçen Havalimanı Transit Turları',
          description: 'Transit sürenizi en iyi şekilde değerlendirin! Her iki havalimanından da özelleştirilmiş turlar.',
          duration: '4-8 saat (esnek)',
          highlights: ['Havalimanı Alınma ve Bırakma', 'Esnek Program', 'Başlıca Turistik Yerler', 'Alışveriş Zamanı'],
          whatsappMsg: 'Merhaba, İstanbul Transit Turu ile ilgileniyorum. Uçuş bilgilerim:\nVarış Uçuş No: \nKalkış Uçuş No: \nTransit Süresi: \nTur için Müsait Süre: Yaklaşık ___ saat\nKişi Sayısı: ',
          details: 'Lütfen İstanbul uçuşunuzun detaylarını ve diğer ilgili bilgileri bize bildiriniz:\n\nVarış ve Uçuş Bilgileri:\n• Varış Uçuş No: ............\n• Kalkış Uçuş No: ............\n• Transit Süresi: ............\n• Tur için Müsait Süre: Yaklaşık ......... Saat\n\nTur Seçeneği: Tam Gün Transit Turu (Özel)\nYerel bir rehber eşliğinde İstanbul\'a rahat ve keyifli bir giriş, ilk kez ziyaret edenler için ideal.\n\nÖnerilen Program:\n• Pasaport kontrolünden sonra havalimanından alınma\n• Sultanahmet\'e (Tarihi Yarımada) transfer\n• Sultanahmet Camii, Ayasofya ve Hipodrom Meydanı ziyareti\n• Arasta Çarşısı veya Mısır Çarşısı\'nda mola\n• Boğaz\'da feribotla Asya yakasına geçiş (isteğe bağlı ve zamana göre)\n• Türk akşam yemeği (kendi hesabınıza) veya yerel sokak yemekleri tadımı\n• Havalimanına geri transfer'
        },
        '4': {
          name: 'İstanbul Yemek Turu - 2 Kıtanın Tadı',
          description: 'İstanbul\'un Avrupa ve Asya yakasında gastronomi yolculuğu. Otantik Türk mutfağını ve yerel lezzetleri deneyimleyin.',
          duration: '5-6 saat',
          highlights: ['Geleneksel Türk Kahvaltısı', 'Sokak Yemekleri', 'Yerel Pazarlar', 'Boğaz Geçişi', 'Tatlılar'],
          whatsappMsg: 'Merhaba, İstanbul Yemek Turu ile ilgileniyorum. Detayları paylaşır mısınız?'
        },
        '5': {
          name: 'İstanbul / Sabiha Gökçen Havalimanı Transferleri',
          description: 'Konforlu ve güvenilir havalimanı transfer hizmetleri. Profesyonel sürücülerle özel araçlar.',
          duration: 'İhtiyaca göre',
          highlights: ['Kapıdan Kapıya Hizmet', 'Profesyonel Sürücüler', 'Modern Araçlar', '7/24 Hizmet', 'Uçuş Takibi'],
          whatsappMsg: 'Merhaba, havalimanı transfer hizmetleriyle ilgileniyorum. Fiyat teklifi alabilir miyim?',
          includedItems: [
            'Havalimanında Karşılama',
            'Kapıdan Kapıya Hizmet',
            'Profesyonel Sürücüler',
            'Modern - Klimalı Araçlar - Araçta İçecek',
            '7/24 Hizmet',
            'Uçuş Takibi'
          ],
          excludedItems: [
            '1-4 yolcu fiyatlandırması',
            '5-10 yolcu fiyatlandırması',
            '11 ve üzeri fiyatlandırması',
            'Teklif için lütfen bizimle iletişime geçin'
          ]
        }
      }
    },
    realEstate: {
      title: 'Yatırım Fırsatları',
      titleHighlight1: 'Yatırım',
      titleHighlight2: 'Fırsatları',
      downloadBrochure: 'Broşürü İndir',
      requestInfo: 'Bilgi İste',
      discoveryCall: 'İstanbul ve Türkiye\'deki yatırım hedeflerinizi görüşmek için 15 dakikalık bir keşif görüşmesi ayırtın.',
      moreProjects: 'Daha fazla proje yakında...',
      officialResources: 'Resmi Yatırım Kaynakları',
      acquiringPropertyTitle: 'Türkiye\'de Mülk Edinme ve Vatandaşlık',
      acquiringPropertyDesc: 'Yabancı uyrukluların mülk edinme ve vatandaşlık prosedürleri, belgeleri ve kılavuzları hakkında resmi rehber.',
      citizenshipGuideTitle: 'Yabancı Vatandaşların Türk Vatandaşlığı Edinim Rehberi',
      citizenshipGuideDesc: 'T.C. Cumhurbaşkanlığı Yatırım Ofisi\'nden kapsamlı resmi PDF rehber.',
      residencePermitTitle: 'İkamet İzni Alma',
      residencePermitDesc: 'Yabancı uyrukluların Türkiye\'de ikamet izni alması için prosedürler ve gerekli belgeler.',
      establishBusinessTitle: 'İş Kurma',
      establishBusinessDesc: 'Türkiye\'de şirket türleri ve kuruluş süreci dahil olmak üzere şirket kurma ve tescil bilgileri.',
      workPermitTitle: 'Çalışma İzni Alma',
      workPermitDesc: 'Yabancı uyrukluların Türkiye\'de yasal olarak çalışabilmeleri için çalışma izni alma kılavuzu.',
      developer: 'Geliştirici',
      status: 'Durum',
      apartmentTypes: 'Daire Tipleri',
      keyFeatures: 'Öne Çıkan Özellikler',
      projectDetails: {
        'besiktas-luxury': {
          name: 'Beşiktaş\'ta Lüks Konut Projesi',
          location: 'Şişli - Mecidiyeköy, İstanbul',
          description: 'İstanbul\'un tarihi dokusu ile modern yaşamı birleştiren, Boğaz manzaralı ayrıcalıklı bir yaşam sunan lüks konut projesi. TOKİ tarafından geliştirilmiştir.',
          highlights: [
            '6 katta 175 daire',
            'Boğaz, peyzaj ve şehir manzarası',
            'Kapalı yüzme havuzu, spor salonu, spa',
            '7/24 güvenlik, kapalı otopark',
            'Metro ve feribota yürüme mesafesi',
            'Türk Vatandaşlığına uygun',
            'İkamet iznine uygun'
          ]
        },
        'nivak-florya': {
          name: 'Bakırköy İlçesinin Kalbinde Ultra Lüks Yaşam Rezidansları',
          location: 'Bakırköy, İstanbul',
          description: 'Gerçekten hak ettiğiniz düzeyde bir yaşam. Doğadan ilham alan mimari, yapay göl ve benzersiz yeşil peyzajlarla özel ve butik bir topluluk.',
          highlights: [
            'Sadece 96 özel konut',
            '3.20 metre üzeri tavan yüksekliği',
            'Sahil şeridine ve sahil parkına birkaç adım',
            'Atatürk Parkı\'na bitişik',
            'Kapalı yüzme havuzu, Türk hamamı, sauna',
            'Fitness merkezi ve Pilates stüdyosu',
            'Futbol ve basketbol sahaları',
            'Türk Vatandaşlığına uygun',
            'Teslime hazır - Haziran 2025'
          ]
        },
        'tual-golyaka-kanal': {
          name: 'Kanal İstanbul Rezidansları Projesi',
          location: 'İstanbul Avrupa Yakası',
          description: 'Modern kentsel yaşamı doğa odaklı tasarımla birleştiren düşük yoğunluklu bir konut projesi. Kanal İstanbul koridoru yakınında, güçlü gelecek değer potansiyeli sunmaktadır.',
          highlights: [
            '26.000 m² arazi - %70 yeşil alan',
            'Yatay düşük katlı mimari',
            'Küçükçekmece Gölü\'ne yakın',
            'TEM Otoyolu\'na kolay erişim',
            'Açık yüzme havuzu ve fitness merkezi',
            'Yürüyüş ve koşu parkurları',
            'Özel bahçeler ve geniş teraslar',
            '7/24 güvenlik, kontrollü giriş',
            'Türk Vatandaşlığına uygun',
            'Kanal İstanbul koridoruna yakın'
          ]
        },
        'alya-merkezefendi': {
          name: 'Fatih İlçesine Yakın Çok Merkezi Yeni Proje',
          location: 'Zeytinburnu, İstanbul',
          description: 'Zeytinburnu\'nun kalbinde mükemmel ulaşım bağlantılarıyla konforlu kentsel yaşam sunan modern bir konut kompleksi.',
          highlights: [
            '467 daire ve 15 ticari birim',
            '17.928 m² arazi, 80.124 m² inşaat alanı',
            'Kapalı yüzme havuzu, fitness salonu',
            'Basketbol ve futbol sahaları',
            'Türk hamamı, sauna, buhar odası',
            'Çocuk oyun alanları ve yürüyüş yolları',
            '7/24 güvenlik, kapalı otopark',
            'Cevizlibağ Metrobüs\'e 650m (yürüme mesafesi)',
            'Türk Vatandaşlığına uygun',
            'İkamet iznine uygun'
          ]
        },
        'skyland-prime': {
          name: 'Şişli Major Prime Gökdelen Rezidansı',
          location: 'Şişli - Maslak, İstanbul',
          description: 'Levent ve Maslak arasında konumlanan Türkiye\'nin en yüksek bina kompleksi. Broadway Malyan\'dan mimar Peter Vaughan tarafından tasarlanmıştır.',
          highlights: [
            'Türkiye\'nin en yüksek bina kompleksi - 1.450 birim',
            '46.000 m² inşaat alanı',
            'Levent ve Maslak arası merkezi konum',
            'VIP giriş lobisi ve akıllı ev sistemi',
            'Kapalı ve açık yüzme havuzları',
            'AVM, yemek alanı, spor salonu',
            'Türk hamamı, sauna, pilates odası',
            '7/24 güvenlik, servis, otopark',
            'TEM Otoyolu\'ndan özel giriş',
            'Orman ve şehir manzarası - Hemen teslim',
            'Türk Vatandaşlığına uygun'
          ]
        }
      }
    },
    investmentInsights: {
      title: 'Yatırım Rehberi: İstanbul Mega Projeleri ve Piyasa Görünümü',
      marketNews: 'Piyasa ve Turizm Haberleri',
    },
    news: {
      title: 'Türkiye\'de Yaşam ve İş Haberleri',
      tourismRevenue: {
        title: 'Türkiye 2025 Turizm Geliri Hedefini Aştı, Yabancı Ziyaretçi Rekoru Kırıldı',
        desc: '2025\'te 64 milyon turist ile 65,2 milyar dolar turizm geliri — her iki rakam da tüm zamanların rekoru.'
      },
      realEstateMarket: {
        title: 'Türkiye Gayrimenkul Pazarı — Avrupa\'nın Güçlü Oyuncusu',
        desc: 'Türkiye, Avrupa\'nın en umut vadeden gayrimenkul pazarlarından biridir. Avrupa, Orta Doğu ve Orta Asya\'nın kesişim noktasında, 85 milyon nüfusa sahiptir. DYY girişleri 11,3 milyar dolara, gayrimenkul DYY\'si ise 2024\'te toplam DYY\'nin %25\'i olan 2,8 milyar dolara ulaştı.',
        cta: 'Daha fazla bilgi için tıklayın'
      },
      tourismRecord: {
        title: 'Türkiye Jeopolitik Zorluklara Rağmen Rekor Turizm Geliri Elde Etti',
        desc: '2025\'te 64 milyon turist ve 65,2 milyar dolar gelir — Türkiye dünyanın en çok ziyaret edilen 4. ülkesi oldu.'
      }
    },
    kanalIstanbul: {
      sectionTitle: 'Kanal İstanbul Projesi',
      projectPurpose: 'Kanal İstanbul - Projenin Amacı',
      projectPurposeDesc: 'Boğaz\'a alternatif bir su yolu olan Kanal İstanbul mega projesinin amacını ve vizyonunu öğrenin.',
      videos: 'Kanal İstanbul - Videolar ve Belgeseller',
      videosDesc: 'Kanal İstanbul proje gelişmeleri hakkında resmi videoları ve belgeselleri izleyin.',
      arabicVideoTitle: 'Kanal İstanbul - Arapça Belgesel',
      arabicVideoDesc: 'Kanal İstanbul projesi belgeselini Arapça izleyin.'
    },
    tersaneIstanbul: {
      sectionTitle: 'Tersane İstanbul',
      description: 'Tersane İstanbul, Türkiye\'nin en büyük endüstriyel miras alanını modern bir kıyı mahallesine ve dünya standartlarında bir destinasyona dönüştüren etkileyici bir kentsel dönüşüm projesidir. Haliç\'in kuzey kıyısındaki tarihi Tersane-i Amire alanında yükselen proje; beş yıldızlı oteller, mağazalar, sosyal alanlar, müzeler, kültür ve performans merkezleri, rezidanslar, marinalar ve Haliç boyunca uzanan yaklaşık iki kilometrelik sahil promenadıyla tarihi kıyıya yeni bir yaşam getiriyor.',
      ourStory: 'Aliée İstanbul - Hikayemiz',
      ourStoryDesc: 'Tarihi Osmanlı tersanesinden Haliç kıyısında dünya standartlarında bir destinasyona uzanan yolculuğu keşfedin.',
      thingsToDo: 'Aliée İstanbul - Yapılacaklar',
      thingsToDoDesc: 'Lüks deneyimleri keşfedin — Boğaz\'da yelken, sanat stüdyoları, Pazar brunchı, biohacking ve Ebru sanatı.'
    },
    goturkiyeBlog: {
      intro: 'Türkiye hakkında her şey..',
      readMore: 'Makaleyi Oku',
      blogTitles: [
        'Dijital Göçebe Vizesi — Türkiye 2026',
        'Merhaba ve Güle Güle Demenin 10 Yolu',
        'İstanbul\'dan Alınacak En İyi 10 Hediyelik Eşya',
        'Türkiye\'nin 10 İkonik Sokak Lezzeti',
        'Türk Mutfağının En Popüler 10 Baharatı',
        'İstanbul\'da Yapılacak 10 Şey',
        'Denemeniz Gereken 10 Türk Tatlısı',
        'Yerel El Sanatları Dükkanlarından 10 Türk Hediyeliği',
        'Türkiye\'de Denemeniz Gereken 16 Yemek',
        'Türkiye\'ye Gittiyseniz Anlayacağınız 13 Şey'
      ]
    },
    digitalNomad: {
      cta: 'En güvenilir ve güncel bilgi için lütfen bağlantıyı ziyaret edin'
    },
    tags: {
      title: 'Etiketlerimiz'
    },
    newsletter: {
      title: 'Bülten',
      description: 'Türkiye\'deki en son haberler, turlar ve yatırım fırsatlarından haberdar olun.',
      emailPlaceholder: 'E-posta adresiniz',
      signUp: 'KAYDOL',
      subscribing: 'Kaydediliyor...',
      success: 'Bültene başarıyla abone oldunuz!',
      invalidEmail: 'Lütfen geçerli bir e-posta adresi girin.',
      error: 'Abone olurken hata oluştu. Lütfen tekrar deneyin.'
    },
    faq: {
      title: 'Sıkça Sorulan Sorular',
      q1: 'İstanbul\'daki en iyi özel tur şirketi hangisidir?',
      a1: 'Viaturkey Investments & Tourism, İstanbul\'da İngilizce, Rusça, Arapça ve Türkçe kişiselleştirilmiş rehberli turlar sunan en iyi özel tur şirketidir. Tarihi Yarımada turları, Boğaz gezileri, yemek turları, liman turları ve havalimanı aktarma turları sunuyoruz. Aracısız doğrudan rezervasyon yapın.',
      q2: 'Yatırım yoluyla Türk vatandaşlığı nasıl alınır?',
      a2: 'En az 400.000 USD değerinde gayrimenkul satın alarak Türk vatandaşlığı alabilirsiniz. Viaturkey, mülk seçiminden vatandaşlık başvurusuna kadar tüm süreçte uzman danışmanlık sağlar.',
      q3: 'Kruvaziyer yolcuları için en iyi İstanbul turları nelerdir?',
      a3: 'Viaturkey, kruvaziyer yolcuları için Ayasofya, Sultanahmet Camii, Topkapı Sarayı ve Kapalıçarşı\'yı kapsayan özel liman turları sunar. Turlar 5-8 saat sürer. Üçüncü parti platformlara kıyasla %25 tasarruf edin.',
      q4: 'İstanbul\'da iş toplantıları için en iyi yerler nerelerdir?',
      a4: 'İstanbul\'da iş toplantıları için en iyi restoranlar: Nusr-Et Steakhouse (Etiler), Paper Moon (Akmerkez), Cipriani (Levent), Ulus 29 (panoramik Boğaz manzarası), Sunset Grill & Bar ve La Petite Maison.',
      q5: 'İstanbul gayrimenkulüne yatırım yapmak güvenli mi?',
      a5: 'Evet, İstanbul gayrimenkulü artan değerleriyle güçlü bir yatırımdır. Türkiye yatırım yoluyla vatandaşlık ve oturma izni sunmaktadır. Viaturkey büyük geliştiricilerle çalışır ve Beşiktaş, Florya gibi birinci sınıf lokasyonlarda projeler sunar.'
    },
    projects: {
      'besiktas-luxury': {
        name: 'Beşiktaş Lüks Konut Projesi',
        location: 'Şişli - Mecidiyeköy, İstanbul',
        description: 'İstanbul\'un tarihi dokusunu modern yaşamla buluşturan, Boğaz manzaralı ayrıcalıklı bir yaşam sunan lüks konut projesi. Premium Developer tarafından geliştirilmiştir.',
        highlights: ['6 katta 175 daire', 'Boğaz, peyzaj ve şehir manzarası', 'Kapalı yüzme havuzu, spor salonu, spa', '7/24 güvenlik, kapalı otopark', 'Metro ve vapur yürüme mesafesinde', 'Türk Vatandaşlığı için uygun', 'İkamet İzni için uygun'],
        apartmentTypes: '1+1\'den 6.5+1\'e kadar', developer: 'Premium Developer', completionStatus: '%90 tamamlandı', pricing: 'Fiyat için iletişime geçin'
      },
      'nivak-florya': {
        name: 'Bakırköy İlçesinin Kalbinde Ultra Lüks Yaşam Rezidansları',
        location: 'Bakırköy, İstanbul',
        description: 'Gerçekten hak ettiğiniz düzeyde bir yaşam tarzı. Doğadan ilham alan mimari, yapay göl ve eşsiz yeşil peyzajlarla özel ve butik bir topluluk.',
        highlights: ['Sadece 96 ayrıcalıklı ünite', 'Tavan yüksekliği 3,20 metreden fazla', 'Sahil ve deniz parkına birkaç adım', 'Atatürk Parkı bitişiğinde', 'Kapalı yüzme havuzu, hamam, sauna', 'Fitness merkezi ve pilates stüdyosu', 'Futbol ve basketbol sahaları', 'Türk Vatandaşlığı için uygun', 'Teslime hazır - Haziran 2025'],
        apartmentTypes: '3 yatak odalı (225 m²), 4-5 yatak odalı villalar, 6-7 yatak odalı dubleks penthouse', developer: 'Premium Developer', completionStatus: 'Teslime hazır', pricing: 'Fiyat için iletişime geçin'
      },
      'tual-golyaka-kanal': {
        name: 'Kanal İstanbul Rezidansları Projesi',
        location: 'İstanbul Avrupa Yakası',
        description: 'Modern şehir yaşamını doğa odaklı tasarımla birleştiren düşük yoğunluklu konut projesi. Kanal İstanbul koridoru yakınında, güçlü değer artış potansiyeli.',
        highlights: ['26.000 m² — %70 yeşil alan', 'Yatay, alçak katlı mimari', 'Küçükçekmece Gölü yakını', 'TEM Otoyolu\'na kolay erişim', 'Açık yüzme havuzu ve fitness merkezi', 'Yürüyüş ve koşu parkurları', 'Özel bahçeler ve geniş teraslar', '7/24 kontrollü giriş güvenliği', 'Türk Vatandaşlığı için uygun', 'Kanal İstanbul koridoru yakını'],
        apartmentTypes: '2+1\'den 5+1\'e, müstakil villa seçenekleri', developer: 'Premium Developer', completionStatus: 'Birden fazla aşama geliştiriliyor', pricing: 'Fiyat için iletişime geçin'
      },
      'alya-merkezefendi': {
        name: 'Fatih İlçesine Yakın Çok Merkezi Yeni Proje',
        location: 'Zeytinburnu, İstanbul',
        description: 'Mükemmel ulaşım bağlantılarıyla Zeytinburnu\'nun kalbinde konforlu kentsel yaşam sunan modern bir konut kompleksi.',
        highlights: ['467 daire ve 15 ticari ünite', '17.928 m² arazi, 80.124 m² inşaat alanı', 'Kapalı yüzme havuzu, fitness salonu', 'Basketbol ve futbol sahaları', 'Hamam, sauna, buhar odası', 'Çocuk oyun alanları ve yürüyüş yolları', '7/24 güvenlik, kapalı otopark', 'Cevizlibağ Metrobüs\'e 650 m', 'Türk Vatandaşlığı için uygun', 'İkamet İzni için uygun'],
        apartmentTypes: '1+1, 2+1, 3+1, 4+1, Dubleks', developer: 'Premium Developer', completionStatus: 'İnşaat halinde', pricing: 'Fiyat için iletişime geçin'
      },
      'skyland-prime': {
        name: 'Şişli Major Prime Gökdelen Rezidansı',
        location: 'Şişli - Maslak, İstanbul',
        description: 'Türkiye\'nin en yüksek bina kompleksi, Levent ile Maslak arasında. Broadway Malyan\'dan mimar Peter Vaughan tasarımı.',
        highlights: ['Türkiye\'nin en yüksek kompleksi — 1.450 ünite', '46.000 m² inşaat alanı', 'Levent ve Maslak arası merkezi konum', 'VIP giriş lobisi ve akıllı ev sistemi', 'Kapalı ve açık yüzme havuzları', 'AVM, yemek alanı, spor salonu', 'Hamam, sauna, pilates odası', '7/24 güvenlik, servis, otopark', 'TEM\'den özel giriş', 'Orman ve şehir manzarası — hemen teslim', 'Türk Vatandaşlığı için uygun'],
        apartmentTypes: 'Konut ve ofis üniteleri', developer: 'Premium Developer', completionStatus: 'Hemen teslim', pricing: 'Fiyat için iletişime geçin'
      },
      'tual-comfort-kanal-2': {
        name: 'Kanal İstanbul Proje Rezidansları 2.',
        location: 'İstanbul Avrupa Yakası',
        description: 'Bahçeşehir\'de 24.000 m² arazi üzerinde %60 yeşil alanlı büyük yatırım fırsatı. İstanbul Havalimanı, Kanal İstanbul koridoru, Kuzey Marmara Otoyolu ve ana arter yolların kesişim noktasında. Her dairede balkon. Tapu hazır.',
        highlights: [
          '6 blokta 480 daire + 20 ticari ünite',
          '24.000 m² arazi — %60 yeşil alan',
          'Küçükçekmece Gölü manzarası',
          'Her dairede balkon',
          'Kapalı yüzme havuzu, sauna ve spa, buhar odası',
          'Fitness merkezi, basketbol sahası, çocuk oyun alanı',
          'Yürüyüş yolları ve aile oturma alanları',
          '7/24 güvenlik, CCTV ve elektronik güvenlik sistemi',
          'İstanbul Yeni Havalimanı\'na 22 km',
          'Küçükçekmece Gölü\'ne 4 km, E80 Otoyolu\'na 3 km',
          'Kanal İstanbul koridoru yakını — yüksek değer artış potansiyeli',
          'Tapu hazır — Mart 2025 teslim',
          'Türk Vatandaşlığı için uygun'
        ],
        apartmentTypes: '2+1 (104-130 m²), 3+1 (163-172 m²)',
        developer: 'Premium Developer',
        completionStatus: 'Teslim edildi — Tapu hazır',
        pricing: 'Fiyat için iletişime geçin'
      },
      'referans-beylikduzu': {
        name: 'Avrupa Yakası Prime Rezidansları',
        location: 'İstanbul Avrupa Yakası',
        description: 'Huzurlu bir aile yaşamı sunan 31.000 m² arsa üzerinde %70 yeşil alanlı konut projesi. 709 konut, eşsiz peyzaj tasarımı, şehir ve deniz manzarası. 300\'den fazla mağaza, AVM, hastane ve West İstanbul Marina\'ya yürüme mesafesinde.',
        developer: 'Premium Developer',
        completionStatus: 'İnşaat devam ediyor',
        apartmentTypes: '2+1, 2+1 Dublex, 3+1, 3.5+1, 3+1 Dublex, 4+1, 4.5+1, 4+1 Dublex, 5+1',
        highlights: [
          '709 konut, 31.000 m² — %70 yeşil alan',
          'Şehir, deniz ve peyzaj manzarası seçenekleri',
          'Açık ve kapalı yüzme havuzları',
          'Zen bahçesi, lavanta ve zeytin bahçesi',
          'Sauna, Türk hamamı, fitness merkezi',
          'Basketbol sahası, çocuk oyun alanı, kreş',
          '300+ mağaza, AVM, hastaneye yürüme mesafesi',
          '7/24 güvenlik sistemi',
          'İstanbul Havalimanı\'na 30 km (45 dk)',
          'Metrobüs ve E-5\'e 5 km',
          'Türk Vatandaşlığına uygun',
          'İkamet iznine uygun'
        ]
      }
    },
    medicalTourism: {
      title: 'Türkiye\'de Sağlık Turizmi',
      subtitle: 'Rekabetçi fiyatlarla dünya standartlarında sağlık hizmetleri — Diş, Saç Ekimi ve Estetik Cerrahi',
      intro: 'Türkiye, 2026 yılında 4,2-4,6 milyar dolarlık pazarıyla medikal turizmin önde gelen destinasyonlarından biridir. İstanbul uluslararası akreditasyonlu hastaneler ve deneyimli uzmanlar sunmaktadır.',
      hairTitle: 'Saç Ekimi SSS',
      h1q: 'DHI mi FUE mi — hangisi daha iyi?',
      h1a: 'Her iki yöntem de kalıcı saç büyümesi sağlar. DHI daha kısa iyileşme süresi sunar. FUE daha geniş alanları 6-8 saatte kaplar. Safir FUE daha keskin bıçaklar kullanır.',
      h2q: 'Kaç greft nakledilir?',
      h2a: 'Her greft yaklaşık 2-3 saç folikülü içerir. Sayı konsültasyon sırasında belirlenir.',
      h3q: 'Kadınlar saç ekimi yaptırabilir mi? İz kalır mı?',
      h3a: 'Evet, FUE yöntemi görünür iz bırakmaz. Ekilen saçlar doğal saçlarla uyumludur.',
      h4q: 'Yan etkiler nelerdir ve ne zaman saç boyanabilir?',
      h4a: 'Geçici şişlik ve uyuşukluk olabilir. Boyama için 8-12 ay beklenmelidir.',
      cosmeticTitle: 'Estetik Cerrahi SSS',
      c1q: 'Burun dolgusu kalıcı mı?',
      c1a: 'Hyalüronik asit dolgu 6-12 ay sürer. Yağ enjeksiyonu 3-5 yıl sürer.',
      c2q: 'Fox Eye tekrarlanabilir mi?',
      c2a: 'Evet, eriyen ipler kullanıldığı için tekrarlanabilir.',
      c3q: 'Fransız askısı yaşlanmayı durdurur mu?',
      c3a: 'Hayır, ancak sarkma ve kırışıklık gibi görünür belirtileri ortadan kaldırır ve kolajen üretimini tetikler.',
      c4q: 'Elmacık kemiği dolgusu kalıcı mı?',
      c4a: 'Hyalüronik asit 6-12 ay, yağ enjeksiyonu 2-3 yıl sürer.',
      healthTurkiye: 'Tedavinizi resmi HealthTürkiye portalında planlayın',
      citation: 'Kaynak: HealthTürkiye (healthturkiye.gov.tr). Piyasa verileri: 2026 sektör analizi.'
    },
    stats: {
      title: 'İstanbul: Temel Bilgiler ve Rakamlar',
      titleCity: 'İstanbul',
      titleFacts: 'Temel Bilgiler ve Rakamlar',
      tourists: 'Uluslararası turist her yıl İstanbul\'u ziyaret ediyor',
      citizenship: 'Türk vatandaşlığı için minimum yatırım',
      residence: 'Türk İkamet İzni için minimum tutar',
      languages: 'Diller: İngilizce, Rusça, Arapça, Türkçe',
      savings: 'Viaturkey ile doğrudan rezervasyonda tasarruf',
      citation: 'Viaturkey Investments & Tourism\'a göre — İstanbul\'un 4 dilde hizmet veren önde gelen tur operatörü ve gayrimenkul danışmanlık şirketi.'
    },
    map: {
      title: 'Ofisimizi Ziyaret Edin',
      openInMaps: 'Google Haritalar\'da Aç'
    },
    contact: {
      title: 'Bize Ulaşın',
      getInTouch: 'İletişime Geçin',
      sendMessage: 'Bize mesaj gönderin',
      openForm: 'İletişim Formunu Aç',
      followYoutube: 'YouTube\'da bizi takip edin',
      followInstagram: 'Instagram\'da bizi takip edin',
      followTiktok: 'TikTok\'ta bizi takip edin',
      followTwitter: 'X (Twitter)\'da bizi takip edin'
    },
    inquiry: {
      title: 'Bilgi Talebi',
      namePlaceholder: 'Adınız *',
      emailPlaceholder: 'E-postanız *',
      phonePlaceholder: 'Telefon Numarası',
      messagePlaceholder: 'Mesajınız *',
      arrivalFlight: 'Varış Uçuş No *',
      departureFlight: 'Kalkış Uçuş No *',
      plannedDate: 'Planlanan Tur Tarihi *',
      specialRequirements: 'Özel İstekler ve Gezginler Hakkında Ek Bilgi',
      flightDetails: 'Uçuş ve Tur Detayları',
      priceQuote: 'En iyi fiyat teklifiyle en kısa sürede sizinle iletişime geçeceğiz.',
      submit: 'Talep Gönder',
      bookCall: 'Randevu Al',
      submitting: 'Gönderiliyor...',
      inquirySuccess: 'Talebiniz başarıyla gönderildi!',
      inquiryError: 'Talep gönderilirken hata oluştu.',
      interestedIn: 'İlgileniyorum'
    },
    footer: {
      rights: '© 2026 Viaturkey Investments & Tourism Co. Tüm hakları saklıdır.',
      tagline: 'Türkiye\'de güvenilir ortağınız'
    },
    tripadvisor: {
      title: 'TripAdvisor Misafirleri Tarafından Tavsiye Edilen',
      linkText: 'Değerlendirmelerimizi Görün',
      text: 'Mükemmel TripAdvisor değerlendirmelerimizle gurur duyuyoruz',
      seeReviews: 'Değerlendirmeleri Gör'
    },
    blog: {
      heroTitle: 'İstanbul Seyahat Blogu',
      heroSubtitle: 'İstanbul yolculuğunuz için uzman rehberler, seyahat ipuçları ve içeriden bilgiler',
      allCategory: 'Tümü',
      cityTours: 'Şehir Turları',
      shoreExcursions: 'Kıyı Gezileri',
      foodCulture: 'Yemek ve Kültür',
      travelTips: 'Seyahat İpuçları',
      turkishCitizenship: 'Türk Vatandaşlığı',
      readMore: 'Devamını Oku',
      backToBlog: 'Bloga Dön',
      posts: [
        { title: 'Galataport\'tan İstanbul Kıyı Gezisi Rehberi', excerpt: 'İstanbul\'daki Galataport kruvaziyer terminalinden mükemmel kıyı gezisini planlamak için bilmeniz gereken her şey.', readTime: '8 dk okuma' },
        { title: 'En İyi İstanbul Yemek Turu: Şehirde Bir Mutfak Yolculuğu', excerpt: 'Sokak kebaplarından Osmanlı saray mutfağına kadar İstanbul\'un canlı yemek sahnesini uzman yerel rehberlerimizle keşfedin.', readTime: '6 dk okuma' },
        { title: 'Yatırımla Türk Vatandaşlığı: 2026 Tam Rehber', excerpt: 'Gayrimenkul yatırımı yoluyla Türk vatandaşlığı edinme adım adım rehberi. Gereksinimler, süreç ve zaman çizelgesi.', readTime: '10 dk okuma' },
        { title: 'Mükemmel İstanbul Şehir Turu Programı: Bir Günde Tarihi Yarımada', excerpt: 'Ayasofya, Sultanahmet Camii, Topkapı Sarayı ve Kapalıçarşı\'yı tek bir rehberli turda nasıl görebilirsiniz.', readTime: '7 dk okuma' },
        { title: 'İlk Kez İstanbul\'a Gelenler İçin 15 Önemli İpucu', excerpt: 'Döviz bozdurmadan ulaşıma kadar İstanbul\'a ilk kez gelen ziyaretçilerin bilmesi gereken her şey.', readTime: '5 dk okuma' },
        { title: 'Kanal İstanbul: Akıllı Yatırımcılar Neden Şimdi Alıyor', excerpt: 'Mega kanal projesi İstanbul\'un Avrupa yakasını yeniden şekillendiriyor. Koridor boyunca gayrimenkul neden yükseliyor.', readTime: '9 dk okuma' }
      ],
      shore: {
        byLine: 'Viaturkey Ekibi',
        intro: 'İstanbul\'a kruvaziyer gemiyle geliyorsanız, dünyanın en heyecan verici kruvaziyer terminallerinden birinde yanaşıyorsunuz — Galataport. Karaköy\'ün kalbinde yer alan Galataport, sizi İstanbul\'un en büyük simge yapılarına ulaştırır. Ancak limanda sınırlı zamanınız olduğunda, verimli bir kıyı gezisi planlamak şarttır.',
        intro2: 'Viaturkey\'de yıllardır kruvaziyer yolcularını İstanbul\'da gezdiriyoruz. İşte kıyıda geçireceğiniz zamanı en iyi şekilde değerlendirmek için bilmeniz gereken her şey.',
        h2_galataport: 'Galataport Nedir ve Neden Önemli?',
        p_galataport1: 'Galataport, Boğaz\'ın Avrupa yakasında yer alan, İstanbul\'un modern kruvaziyer terminalidir; ilk kruvaziyer gemisini 2021\'de ağırladı. Eski terminalden farklı olarak merkezi konumdadır — Taksim Meydanı, Mısır Çarşısı ve tarihi Sultanahmet bölgesine dakikalar mesafededir.',
        p_galataport2: 'Kruvaziyer yolcuları için bu bir devrim niteliğindedir. Galataport\'tan özel bir kıyı gezisi, eski liman konumuna kıyasla daha kısa sürede daha fazla yer görmenizi sağlar.',
        h2_itinerary: 'En İyi Program: 6-8 Saatte Kıyı Gezisi',
        p_itinerary: 'İşte lisanslı İstanbul rehberlerimizin limanda 6-8 saati olan ilk kez ziyaretçilere önerdiği program:',
        stops: ['Ayasofya — 1500 yıllık mimari başyapıt. Önce kilise, sonra cami, şimdi yine cami. Özel rehberle biletleri ve zamanlamayı biz ayarlıyor, daha sakin giriş saatlerini seçiyoruz.', 'Sultanahmet Camii — Altı minaresi ve basamaklı kubbeleriyle İstanbul\'un en ünlü camii.', 'Topkapı Sarayı — 400 yıl boyunca Osmanlı sultanlarının ikametgahı. Harem bölümü ve hazine mutlaka görülmeli.', 'Kapalıçarşı — 4000\'den fazla dükkanıyla dünyanın en eski ve en büyük kapalı çarşılarından biri.', 'Mısır Çarşısı — Lokum, safran, kuru meyve ve el yapımı çaylarla dolu bir lezzet şöleni.'],
        h2_why: 'Gemi Gezileri Yerine Neden Özel Tur?',
        p_why: 'Gemi gezileri rahat olsa da dezavantajları vardır: kalabalık gruplar (30-50 kişi), katı programlar ve %25-40 daha yüksek fiyatlar. İşte Viaturkey ile özel turun neden daha iyi bir seçim olduğu:',
        reasons: ['Kişiselleştirilmiş tempo — Programı siz belirlersiniz', 'Lisanslı yerel rehber — Tüm rehberlerimiz devlet lisanslıdır', 'Kapıdan kapıya hizmet — Galataport\'ta karşılar, geminize geri götürürüz', '%25+ tasarruf — Aracısız doğrudan rezervasyon', 'Gemi kalkış garantisi — Geminizin programını takip eder, zamanında dönmenizi sağlarız'],
        h2_food: 'Kıyı Geziniz Sırasında Yemek Durakları',
        p_food: 'İstanbul ziyareti yemek tadımı olmadan tamamlanamaz. Kıyı geziniz sırasında seçilmiş yerel restoranlarda duraklar dahildir:',
        foodStops: ['Simit, peynir, zeytin ve taze demlenmiş çayla otantik Türk kahvaltısı', 'Kapalıçarşı yakınında aile işletmesi restoranda ünlü İstanbul kebapları', 'Yüz yıllık pastanede baklava tadımı', 'Seyyar satıcıdan taze sıkılmış nar suyu'],
        foodLink: 'İstanbul yemek turu paketleri',
        h2_know: 'Kıyı Gezinizden Önce Bilmeniz Gerekenler',
        knowItems: ['Para birimi: Türk Lirası (TL). Çoğu turistik yer kredi kartı kabul eder, ancak çarşılar için nakit bulundurun.', 'Kıyafet kuralı: Camiler kapalı omuz ve diz gerektirir. Başörtüsü girişte sağlanır.', 'En iyi aylar: Ilıman hava ve daha az kalabalık için Nisan-Haziran ve Eylül-Kasım.', 'Dil: Rehberlerimiz İngilizce, Rusça, Arapça ve Türkçe konuşur.'],
        h2_faq: 'Sık Sorulan Sorular',
        faqs: [
          { q: 'Galataport kıyı gezisi ne kadar sürer?', a: 'Çoğu kıyı gezisi 6-8 saat sürer, bu tüm önemli noktaları kapsamak için yeterlidir. Geminizin programına göre özelleştiririz.' },
          { q: 'Gemiye zamanında dönmemizi garanti edebilir misiniz?', a: 'Kesinlikle. Geminizin kalkış programını takip eder ve güvenlik tamponu bırakırız. Yıllarca süren hizmetimizde hiçbir misafir gemisini kaçırmamıştır.' },
          { q: 'İngilizce dışında dillerde tur sunuyor musunuz?', a: 'Evet. Lisanslı rehberlerimiz İngilizce, Rusça, Arapça ve Türkçe turlar sunar.' },
          { q: 'Özel kıyı gezisi ne kadar tutar?', a: 'Fiyatlar grup büyüklüğüne ve programa bağlıdır. WhatsApp\'tan bize ulaşın — genellikle gemi gezilerinden %25 daha ucuzdur.' }
        ],
        ctaTitle: 'İstanbul Kıyı Gezinizi Rezerve Etmeye Hazır mısınız?',
        ctaText: 'Kişiselleştirilmiş bir program ve anında fiyat teklifi için doğrudan WhatsApp\'tan yazın. Aracı yok, gizli ücret yok.',
        ctaBtn: 'WhatsApp\'tan Yazın'
      }
    },
    newProject: {
      badge: 'YENİ PROJE',
      title: 'Merkezi İstanbul Metro Rezidansları 2026 — Satışta',
      subtitle: 'İstanbul Basın Ekspres aksında premium konutlar · 259.000 USD\'den başlayan fiyatlar · Türk Vatandaşlığına uygun (min. 400.000 USD yatırım)',
      cta: 'Projeyi İncele'
    }
  };

